import classes from './scenario-icon-group.module.scss';
import { create, registerCustomElement } from '../utils.mjs';
import { SCENARIO_TOOL_VISIBLE_PACKAGE_COUNT } from './scenario-list-item.mjs';

export class ScenarioIconGroup extends HTMLElement {
	static create({ packages = [], repository = null, visiblePackagesCount = SCENARIO_TOOL_VISIBLE_PACKAGE_COUNT }) {
		const iconGroup = new ScenarioIconGroup();

		iconGroup.packages = packages;
		iconGroup.repository = repository;
		iconGroup.visiblePackagesCount = visiblePackagesCount;

		return iconGroup;
	}

	static get observedAttributes() {
		return ['name', 'enabled'];
	}

	connectedCallback() {
		this.render();
	}

	disconnectedCallback() {
		this.innerHTML = '';
	}

	updateIconTheme(ele, packageName) {
		this.repository
			?.get(packageName)
			.then(({ theme }) => {
				ele.style.backgroundColor = theme.toHex?.() || theme;
			})
			.catch(console.warn);
	}

	render() {
		const { packages, visiblePackagesCount } = this;

		const icons = Array.from(new Array(visiblePackagesCount), (_, i) => {
			const packageName = packages[visiblePackagesCount - (i + 1)];

			// Render placeholder
			if (!packageName) {
				return `<div class="${classes.icon}"><div class="${classes.placeholder}"></div></div>`;
			}

			const isLastPackage = i === visiblePackagesCount - 1;
			const remainingPackages = packages.length - visiblePackagesCount;

			if (isLastPackage && remainingPackages > 0) {
				return `<div class="${classes.icon} ${classes.iconMore}">+${remainingPackages + 1}</div>`;
			}

			const src = getPackageIconSource(packageName);

			return `<img data-name=${packageName} class="${classes.icon}" src="${src}"></img>`;
		});

		const template = document.createElement('template');
		template.insertAdjacentHTML('beforeend', icons.join(''));

		template.querySelectorAll('img').forEach((img) => {
			// Handle imgs that fail to load
			img.onerror = () => {
				const replacement = create(`div.${classes.icon}`);
				replacement.appendChild(create(`div.${classes.placeholder}`));
				img.replaceWith(replacement);
			};

			const packageName = img.getAttribute('data-name');
			if (packageName) {
				this.updateIconTheme(img, packageName);
			}
		});

		this.classList.add(classes.iconGroup);

		// Add class based on visiblePackagesCount for styling
		if (visiblePackagesCount === 1) {
			this.classList.add(classes.singleIcon);
		}

		this.append(...template.children);
	}
}

function getPackageIconSource(appName, imageSize = 32) {
	const mapImage = imt.static || ((url) => `static${url}`);

	if (/^app#/.test(appName)) {
		return mapImage(`/img/apps/${appName?.substring(4)}_${imageSize}.png`);
	}

	return mapImage(`/img/packages/${appName}_${imageSize}.png`);
}

registerCustomElement('imt-scenario-icon-group', ScenarioIconGroup);
